import React, {FC} from 'react'
import {Redirect, Route, Switch, useRouteMatch} from 'react-router-dom'

import {useCompany} from '@progyny/hooks/useCompany'
import {useProductLine} from '@progyny/hooks/useProductLine'
import PartnerAgreement from '@progyny/pages/Budget/PartnerAgreement'
import Faq from '@progyny/pages/Faq'
import {ProfileIndexPage} from '@progyny/pages/Profile'
import BankDetails from '@progyny/pages/Profile/BankDetails'
import MemberStatus from '@progyny/pages/Profile/member-status'
import {PersonalInfoPage} from '@progyny/pages/Profile/personal-info'
import Security from '@progyny/pages/Profile/security'
import SwitchJourney from '@progyny/pages/SwitchJourney'
import {useMeStore} from '@progyny/store/meStore'

export const ProfRoutes = {
  PERSONAL_INFO: '/personal-info',
  SECURITY: '/security',
  MEMBER_STATUS: '/member-status',
  FAQ: '/faq',
  EXPLORE_JOURNEY: '/explore-journey',
  PARTNER_DETAILS: '/partner-agreement',
  PAYMENT_DETAILS: '/bank-details',
}

const ProfileRoutes: FC = () => {
  const {url} = useRouteMatch()
  const isCompanyMeta = useCompany('Meta')
  const companyHasBudget = useMeStore((s) => s.companyHasBudget)
  const {productLine} = useProductLine()

  // Block member-status and faq routes for menopause and pregnancy product lines
  const isMenopauseOrPregnancy =
    productLine === 'menopause' || productLine === 'pregnancy_and_postpartum'

  return (
    <Switch>
      <Route exact path={`${url}/`} component={ProfileIndexPage} />

      <Route
        path={`${url}${ProfRoutes.PERSONAL_INFO}`}
        component={PersonalInfoPage}
      />
      <Route
        path={`${url}${ProfRoutes.EXPLORE_JOURNEY}`}
        component={SwitchJourney}
      />
      <Route path={`${url}${ProfRoutes.SECURITY}`} component={Security} />

      {/* Block FAQ route for menopause and pregnancy */}
      {!isMenopauseOrPregnancy && (
        <Route path={`${url}${ProfRoutes.FAQ}`} component={Faq} />
      )}

      {/* Block Member Status route for menopause and pregnancy */}
      {!isMenopauseOrPregnancy && !isCompanyMeta && companyHasBudget && (
        <Route
          path={`${url}${ProfRoutes.MEMBER_STATUS}`}
          component={MemberStatus}
        />
      )}
      <Route
        path={`${url}${ProfRoutes.PARTNER_DETAILS}`}
        component={PartnerAgreement}
      />
      <Route
        path={`${url}${ProfRoutes.PAYMENT_DETAILS}`}
        component={BankDetails}
      />
      <Route path={`${url}${ProfRoutes.SECURITY}`} component={Security} />
      <Route path={`${url}${ProfRoutes.FAQ}`} component={Faq} />

      <Redirect path={`${url}/*`} to={`/404`} />
    </Switch>
  )
}
export default ProfileRoutes
